enum FinancialInterest {
    Active,
    Passive,
    Relative,
    None,
}

export default FinancialInterest;
